import _toConsumableArray from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import isEqual from 'lodash/isEqual';
import xorWith from 'lodash/xorWith';
import joinName from './joinName';
export default function changedKeys(root, valueA, valueB) {
  if (!valueA || valueA !== Object(valueA) || valueA instanceof Date) return isEqual(valueA, valueB) ? [] : [root];
  if (!valueB) return [root].concat(_toConsumableArray(Object.keys(valueA).map(function (key) {
    return joinName(root, key);
  })));
  var changed = xorWith(Object.entries(valueA), Object.entries(valueB), isEqual).map(function (pair) {
    return joinName(root, pair[0]);
  });
  if (changed.length) changed.unshift(root);
  return changed;
}